export interface Template {
  id: string;
  name: string;
  type: "email" | "pdf";
  category: string;
  subject?: string;
}

// Block 5.5 — AI call-transcript metadata on a channel='phone' communication.
export interface CallMeta {
  source: string;
  summary: string;
  topics?: string[];
  callerName?: string;
  callerPhone?: string;
  destination?: string;
  budget?: string;
  requestedDate?: string;
  followUpAt?: string;
  followUpNote?: string;
  followUpAppliedAt?: string;
  recordingUrl?: string;
  at: string;
}

export interface Communication {
  id: string;
  type: "email" | "phone" | "note" | "sms";
  direction: "inbound" | "outbound";
  channel?: string;
  subject?: string;
  content?: string;
  emailStatus?: string;
  meta?: { call?: CallMeta } | null;
  createdAt: string;
  createdBy?: string;
}

export interface Order {
  id: string;
  orderNumber: string;
  status: string;
  totalPrice: number;
  createdAt: string;
  trip?: {
    title: string;
  };
  tripDate?: {
    startDate: string;
  };
}

export interface Customer {
  id: string;
  email: string;
  phone?: string;
  firstName?: string;
  lastName?: string;
  street?: string;
  city?: string;
  zip?: string;
  country?: string;
  birthDate?: string;
  passportNumber?: string;
  passportExpiry?: string;
  nationality?: string;
  totalSpent: number;
  tripsCount: number;
  firstTripDate?: string;
  lastTripDate?: string;
  score: number;
  newsletterSubscribed: boolean;
  notes?: string;
  source?: string;
  anonymizedAt?: string | null;
  createdAt: string;
  orders?: Order[];
}

export const STATUS_CONFIG: Record<string, { label: string; className: string }> = {
  inquiry: { label: "Inquiry", className: "bg-gray-100 text-gray-700" },
  quoted: { label: "Quoted", className: "bg-blue-100 text-blue-700" },
  confirmed: { label: "Confirmed", className: "bg-purple-100 text-purple-700" },
  deposit_paid: { label: "Deposit paid", className: "bg-warning-100 text-warning-700" },
  fully_paid: { label: "Fully paid", className: "bg-success-100 text-success-700" },
  completed: { label: "Completed", className: "bg-success-100 text-success-700" },
  cancelled: { label: "Cancelled", className: "bg-error-100 text-error-700" },
};
